<div #elementRef class="ui toggle checkbox" [class.disabled]="disabled">
  <input
    type="checkbox" #checkbox
    [disabled]="disabled"
    (change)="toggle(checkbox.checked)"
  >
  <label>{{label}}</label>
</div>
